import axios from "axios";
import { useEffect, useState } from "react";
import pageArray from "../components/Pagination/helpers/pageArray";

const useAxios = (endPoint) => {
	let baseUrl = window.origin;
	let reqUrl = `${baseUrl}/wp-json/futurpreneur/v1/${endPoint}`;
	const loadingText = () => {
		if (endPoint.includes('lang=fr')) return 'Chargement des résultats';
		return 'Loading results';
	}
	
	const [response, setResponse] = useState([]);
	const [totalPages, setTotalPages] = useState([]);
	const [message, setMessage] = useState(loadingText());

	useEffect(() => {
		const getResponse = async () => {
			const formatDataArray = (responseData) => {
				if (Array.isArray(responseData)) return responseData;
				return [responseData];
			}

			const checkEndpoint = (endPoint, response) => {
				if (response.data.message) return [];

				if (endPoint.includes('news') || endPoint.includes('resources') || endPoint.includes('press-release') || endPoint.includes('stories')) return response.data.data;
				return response.data;
			}

			try {
				const response = await axios.get(reqUrl);
				let responseData = checkEndpoint(endPoint, response);
				const dataArray = formatDataArray(responseData);
				
				if (dataArray.length) {
					setMessage('');
					setResponse([...dataArray]);

					// not all responses will have postCount so we check for it here
					if (response.data.postCount) {
						if (endPoint.includes("stories")) {
							setTotalPages(pageArray(Math.ceil(response.data.postCount / 10)));
							return;
						}

						setTotalPages(pageArray(Math.ceil(response.data.postCount / 18)));
					}
				} else {
					setResponse([]);
				}
			} catch (error) {
				throw new Error(error); // eslint-disable-line
			}
		};
		getResponse();
	}, [endPoint]);
	
	return { response, totalPages, message };
};

export default useAxios;